import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/app/core/auth/auth.service';

@Component({
  selector: 'rqa-access-denied',
  template: `
    <div class="full-container pt-5 lg:pr-5 lg:pl-5 w-full pb-6">
      <section class="flex justify-content-between mb-5 align-items-center px-3 lg:px-0">
        <div>
          <h1 class="text-2xl mx-0 my-0 title">{{ 'accessDenied.title' | translate }}</h1>
          <p>{{ 'accessDenied.message' | translate }}</p>
        </div>
      </section>

      <div class="accessible-routes" *ngIf="accessibleRoutes.length > 0">
        <h3>{{ 'accessDenied.availableRoutes' | translate }}</h3>
        <ul>
          <li *ngFor="let route of accessibleRoutes">
            <a [routerLink]="['/' + route.path]">{{ 'routes.' + route.path | translate }}</a>
          </li>
        </ul>
      </div>
    </div>
  `,
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule]
})
export class AccessDeniedComponent {
  private authService = inject(AuthService);

  accessibleRoutes = this.authService.getAccessibleRoutes();
}
